<template>
  <div class="page-security">
    <div class="container">
      <div class="page-header">
        <h2>{{ step === 1 ? '温馨提示' : '安全验证' }}</h2>
      </div>
      <div class="page-body">
        <div class="mod-step1" v-if="step === 1">
          <template v-if="hasAuth">
            <p>尊敬的旅客{{ info }}，您已长时间未使用动态登录，为了您的账号安全，请输入会员密码或身份证后六位进行验证后登录。</p>
            <div class="form">
              <a-input-group size="large" compact>
                <a-select size="large" v-model="verifyType">
                  <a-select-option value="idCard">
                    身份证后6位
                  </a-select-option>
                  <a-select-option value="password">
                    密码
                  </a-select-option>
                </a-select>
                <a-input v-if="verifyType === 'idCard'" :placeholder="verifyPlaceholder" v-model.trim="verifyValue" />
                <a-input v-if="verifyType === 'password'" type="password" :placeholder="verifyPlaceholder" v-model.trim="verifyValue" />
              </a-input-group>
            </div>
            <div class="action">
              <a-button size="large" :loading="loading" @click="onRegister">我是新用户</a-button>
              <a-button size="large" :loading="loading" type="primary" @click="onAuthLogin">登录</a-button>
            </div>
          </template>
          <template v-else>
            <p>您的账号{{ info }}已长时间未登录{{ app.name }}网站，本次登录 需要验证您的历史账号信息，请前往安全验证</p>
            <div class="action">
              <a-button size="large" :loading="loading" @click="onRegister">我是新用户</a-button>
              <a-button size="large" :loading="loading" type="primary" @click="onVerify">安全验证</a-button>
            </div>
          </template>
        </div>
        <div class="mod-step2" v-else>
          <order-form></order-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import queryString from 'query-string'
import OrderForm from './components/OrderForm'
import { securityCreate, securityVerify } from '@/api/member'
import fromApp from '@/utils/from'
import './index'

export default {
  data () {
    return {
      step: 1,
      hasAuth: true,
      info: '',
      verifyType: 'idCard',
      verifyValue: '',
      loading: false,
      app: null
    }
  },
  created () {
    const params = queryString.parse(location.search)
    this.hasAuth = parseInt(params.hasAuth) === 1
    this.info = params.info || ''
    this.app = fromApp()
  },
  computed: {
    verifyPlaceholder () {
      return this.verifyType === 'idCard' ? '请输入身份证后六位' : '请输入登录密码'
    }
  },
  methods: {
    // 我是新用户 - 注册新用户
    async onRegister () {
      this.loading = true

      try {
        const data = await securityCreate({})

        this.$success({
          content: '登录成功',
          centered: true,
          onOk: () => {
            if (!data.fullName) {
              data.fullName = '手机用户'
            }

            this.$ls.set('USER_CENTER_INFO', data)
            window.__MICRO_ROOT__ && window.__MICRO_ROOT__.eventBus.emit('user.login.success', null, {
              ...data,
              token: this.$ls.get('USER_CENTER_TOKEN')
            })
          }
        })
      } catch (err) {
        this.$error({
          content: err.message,
          centered: true
        })
        this.loading = false
      }
    },
    // 轻用户 - 安全验证到第二步
    onVerify () {
      this.step = 2
    },
    // 已补充资料用户 - 登录
    async onAuthLogin () {
      const { verifyType, verifyValue, verifyPlaceholder } = this

      if (!verifyValue) {
        this.$error({
          content: verifyPlaceholder,
          centered: true
        })
        return
      }

      this.loading = true

      try {
        const params = {
          type: verifyType === 'idCard' ? 1 : 5
        }

        if (verifyType === 'idCard') {
          params.idcard = verifyValue
        } else {
          params.password = verifyValue
        }

        const data = await securityVerify({
          check: params
        })

        this.$success({
          content: '登录成功',
          centered: true,
          onOk: () => {
            if (!data.fullName) {
              data.fullName = '手机用户'
            }

            this.$ls.set('USER_CENTER_INFO', data)
            window.__MICRO_ROOT__ && window.__MICRO_ROOT__.eventBus.emit('user.login.success', null, {
              ...data,
              token: this.$ls.get('USER_CENTER_TOKEN')
            })
          }
        })
      } catch (err) {
        this.$error({
          content: err.message,
          centered: true
        })
        this.loading = false
      }
    }
  },
  filters: {
    mix (value) {
      return '*'.repeat(value.length - 1) + value.substr(-1, 1)
    }
  },
  components: {
    OrderForm
  }
}
</script>
